export default __webpack_public_path__ + "static/media/component_geared_motor.1403ccbe.png";